import {} from "react-admin";
import { Divider, Grid, Typography } from "@mui/material";
import { CargoList } from "./components/cargo-list";
import { DriverSchedulingList } from "./components/drivers-scheduling/driver-scheduling-list";
import CargoContext from "../contexts/CargoContext";
import React from "react";
import { FleetMatchingDrivers } from "./fleets/fleets/fleet-matching-drivers";
import UserContext from "../contexts/UserContext";
// 调度推荐页面
export const Scheduling = () => {
  const { selectedCargo: rawSelectedCargo } = React.useContext(CargoContext);
  const { isScheduler } = React.useContext(UserContext);
  const selectedCargo = React.useMemo(
    () => rawSelectedCargo,
    [rawSelectedCargo]
  );

  return (
    <Grid container spacing={3}>
      <Grid
        item
        xs={12}
        md={isScheduler ? 6 : 12}
        style={{ maxHeight: "96vh", overflowY: "auto" }}
      >
      <Typography>有效货物</Typography>
        <CargoList />
      </Grid>
      {isScheduler && (
        <Grid item xs={12} md={6}>
          <Typography>匹配司机（仅App）</Typography>
          {selectedCargo && (
            <DriverSchedulingList selectedCargo={selectedCargo} />
          )}
          <Divider style={{ margin: "20px 0" }} />
          <Typography>匹配车队司机（多渠道）</Typography>
          {selectedCargo && (
            <FleetMatchingDrivers selectedCargo={selectedCargo} />
          )}
        </Grid>
      )}
    </Grid>
  );
};
